import 'vuetify/styles/main.css';
import '@/assets/v-text-field-fix.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { mdi } from 'vuetify/iconsets/mdi';
import { fa } from 'vuetify/iconsets/fa';
import { it } from 'vuetify/locale';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          'primary': '#019587',
          'sicura': '#947ca8',
          'primary-sicura': '#947ca8',
          'organization': '#78C0E0',
          'info': '#2196f3',
          'warning': '#ffc107',
          'error': '#f44336',
          'success': '#4caf50',
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    sets: {
      mdi,
      fa,
    },
  },
  locale: {
    locale: 'it',
    messages: { it },
  },
});

export { vuetify };
